import { NgModule } from '@angular/core';
import { UserModule } from './user/user.module';
import { TransactionsModule } from './transactions/transactions.module';
import { PaymentModule } from './payment/payment.module';
import { CustomerModule } from './customer/customer.module';
import { ReportsModule } from './reports/reports.module';
import { BillingModule } from './billing/billing.module';
import { AdminModule } from './admin/admin.module';
import { FlashpayModule } from 'features/flashpay/flashpay.module';
import { StaticContent } from './static-content/static-content.module';
import { HostedPaymentModule } from './hosted-payment/hosted-payment.module';
import { AdminDashboardModule } from './admin-dashboard/admin-dashboard.module';
import { SystemAdminModule } from './system-admin/system-admin.module';
import { SupportModule } from './support/support.module';
import { NotificationsModule } from './notifications/notifications.module';

@NgModule({
  imports: [
    UserModule,
    TransactionsModule,
    PaymentModule,
    CustomerModule,
    AdminModule,
    ReportsModule,
    BillingModule,
    FlashpayModule,
    StaticContent,
    HostedPaymentModule,
    AdminDashboardModule,
    SystemAdminModule,
    SupportModule,
    NotificationsModule,
  ]
})
export class FeaturesModule { }
